import React from 'react';

export const formatEmploymentTypeText = (employmentTypes) => {
  return employmentTypes && employmentTypes.length > 0
    ? `Seeks ${employmentTypes.join('/')} Work`
    : '';
};

export const truncateName = (name) => {
  if (!name) {
    return '';
  }

  return name.length > 20 ? name.slice(0, 20) + '…' : name;
};

export const formatDateMMDDYYYY = (date) => {
  if (!date) {
    return '';
  }
  try {
    const dateObj = new Date(date);
    // Checks for valid date, returns empty string if not valid
    if (!Number.isNaN(dateObj.getTime())) {
      return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
    }
    return '';
  } catch (error) {
    /* istanbul ignore next */
    return '';
  }
};

export const formatToMDY2Digits = (input) => {
  if (!input) return '';
  let d;
  if (input instanceof Date) {
    d = input;
  } else {
    const iso = /^(\d{4})-(\d{2})-(\d{2})$/;
    const m = String(input).match(iso);
    if (m) {
      d = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    } else {
      const parsed = new Date(input);
      if (Number.isNaN(parsed)) return '';
      d = parsed;
    }
  }
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

export function formattedYearOfExperience(yearsOfExperience) {
  /** note this only works assuming that the search string
   *  is the first element of the string.  If this changes down the road
   *   we may have some problems.
   */
  function injectStrongTags(value) {
    /** exp levels we expect */
    const expLevels = ['Entry Level', 'Intermediate', 'Expert', 'Management'];
    /** finds the exp level we need */
    let index = expLevels.findIndex(
      function checkExperienceLevelInString(expLevel) {
        return value.includes(expLevel);
      });
    /** if for some reason the string doesn't have
      the expected exp levels, we just return
      the value so we have something
    */
    /* istanbul ignore next */
    if (index === -1) {
      return value;
    }
    /** Pull out the part that doesn't need to be bold */
    let strArr = value.split(expLevels[index]);
    /** return the formatted string */
    return (<><p>{expLevels[index] + strArr.join(' ')}</p></>);
  }

  return injectStrongTags(yearsOfExperience);
}

export const composeLocationText = (zipCode, city, state) => {
  let locationStr = '';
  if (city) {
    locationStr = locationStr.concat(city + ', ');
  }
  if (state) {
    locationStr = locationStr.concat(state + ' ');
  }
  if (zipCode) {
    locationStr = locationStr.concat(zipCode);
  }
  return locationStr.trim();
};

export const stringReplaceJSX = (string, find, replace) => {
  const formattedArray = string?.split(find)?.flatMap((item) => [item, replace]);
  formattedArray?.pop();
  return formattedArray;
};

export function createCopiedTitle(title) {
  return title?.slice(-6) === '(Copy)' ? title : `${title} (Copy)`;
}

export function capitalizesFirstLetters(title) {
  if (title?.trim()?.length > 0) {
    return title.trim().split(/\s+/).map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    }).join(' ');
  }
  return title;
}

export const calculateTextBoxRows = (str, minRows = 1, width = 0) => {

  if (!width) {
    return minRows;
  }

  const newLines = str?.split(/\r\n|\r|\n/).length;
  const charCount = str.length;

  // 9.2 is a rough calculation of the ratio for number of chars on a line based on the width of the textbox
  const charCountDivisor = width / 9.2;
  const calculatedRows = newLines + charCount / charCountDivisor;
  return Math.max(minRows, calculatedRows);
};
